module.exports = __webpack_public_path__ + "static/media/img3.629d23a3.jpg";